<template>
    <div class="section">
        <div style="padding-bottom: 20px">
            <span class="heading-text">Hi, I am <span class="highlight-text">Aoyu Wu</span>.</span>
        </div>
    </div>
</template>

<script lang="ts">
import "bootstrap/dist/css/bootstrap.css";

import { defineComponent } from "vue";
import { useStore } from "vuex";

import { onMounted, computed, reactive, toRefs, h, watch } from "vue";

export default defineComponent({
    name: "App",
    components: {},
    setup() {
        const store = useStore();

        const state = reactive({});

        return {
            ...toRefs(state),
        };
    },
    computed: {},
});
</script>

<style rel="stylesheet" lang="scss">
</style>
